<template>
  <div class="w-full h-full relative flex justify-center">
    <div class="p-8 w-full">
      <div class="flex justify-end"></div>
    </div>
    <div class="absolute bottom-[17%] flex flex-col items-center">
      <div
        class="relative flex items-center justify-center w-[300px] h-[300px] scale-[1.3]"
      >
        <div class="absolute">
          <div class="" confettiAtCenter="true" id="confettiContainer"></div>
        </div>
        <div class="relative z-[2000000000]">
          <LottieComponent />
        </div>
      </div>
      <div class="py-4"></div>
      <div class="text-[#11151D] text-2xl font-bold">
        {{ appVersionData.title }}
      </div>
      <div class="py-1"></div>
      <div class="text-[#727980] text-sm text-center">
        {{ appVersionData.appUpdateText }}
      </div>
      <div class="py-2"></div>

      <a
        v-if="appVersionData.appLink"
        class="px-12 py-6 shadow rounded-2xl text-white bg-[#11151D]"
        :href="appVersionData.appLink"
      >
        {{ $t("appUpdate.update") }}
      </a>
    </div>
  </div>
</template>

<script>
import LottieComponent from "../utils/LottieComponent.vue";

export default {
  components: { LottieComponent },
  name: "TransactionFinishedScreen",
  data() {
    return {
      appVersionData: {},
    };
  },
  mounted() {
    this.loadAppData();
  },
  methods: {
    async loadAppData() {
      const appVersionData = await this.$Events.sendDataRequestResolve(
        "appVersionData"
      );
      this.appVersionData = appVersionData.metaData;
    },
  },
};
</script>
